/**
 * Utility function to add a 'dis' parameter to image URLs.
 * This is used to ensure that images are served with the correct width for display.
 *
 * @param {string} url - The base URL of the image.
 * @param {number} dis - The desired width for the image.
 * @returns {string} The modified URL with the 'dis' parameter appended.
 */
export const addDisParameter = (url, sw) => {
    if (!url) return url
    const separator = url.includes('?') ? '&' : '?'
    return `${url}${separator}sw=${sw}`
}
